export default {
  'forgot.password.title': 'Forgot password',
  'forgot.password.description': 'Enter email information to regain new passwords',
  'forgot.password.notification':
    'The password recovery link has been sent to your email.Please check the email and click on the link attached in the mail to start reset the password.',
  'forgot.password.email': 'email',
  'forgot.password.button.accept': 'Confirm',
  'forgot.password.email.not.exit': 'Email does not exist',
  'forgot.password.email.invalid': 'Email is not a valid email!',
  'forgot.btn.account': 'Continue',
};
